







































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { isUnitBankDarah } from "@/utils/unit";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import HasilDarahSvc from "@/services/HasilPemeriksaanDarah";
import { storeHasilPemeriksaanDarah } from "@/store/modules/HasilPemeriksaanDarahStore";
import HasilBankDarahFormDialog from "./HasilBankDarahFormDialog.vue";
import PersetujuanTransfusiInkompatibelTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/transfusi-darah/PersetujuanTransfusiInkompatibelTabPage.vue";
import StorePersetujuanInkompatibel from "@/store/modules/PersetujuanTransfusiInkompatibel";
import {
  HasilDarahJenis,
  HasilDarahRecord
} from "@/types/hasil_pemeriksaan_darah";

@Component({
  components: {
    CardModalTtd,
    HasilBankDarahFormDialog,
    PersetujuanTransfusiInkompatibelTabPage
  }
})
export default class CardHasilBankDarah extends Vue {
  @Prop() readonly register!: string;

  @Prop() readonly rm!: string;

 
  @Prop({ type: Boolean, default: false })
  readonly showConsentShortcut!: boolean;

  @Prop({ type: String, default: null }) readonly jenisAwal!: string | null;

  tabAktif: string | null = null;

  formDialog = false;

  editData: HasilDarahRecord | null = null;

  formJenis: HasilDarahJenis = "komponen_darah";

  modalTtd = false;

  signItem: HasilDarahRecord | null = null;

  dialogHapus = false;

  hapusItem: HasilDarahRecord | null = null;

  deleting = false;

  dialogPersetujuan = false;

  persetujuanHasil: HasilDarahRecord | null = null;

  persetujuanBukaForm = false;

  persetujuanNonce = 0;

  get items(): HasilDarahRecord[] {
    return storeHasilPemeriksaanDarah.items || [];
  }

  get loading(): boolean {
    return storeHasilPemeriksaanDarah.loading;
  }

  get userId(): number | null {
    return userModule.user ? userModule.user.id : null;
  }

  get persetujuanItems(): any[] {
    return StorePersetujuanInkompatibel.suket || [];
  }

  get persetujuanKey(): string {
    const hasilId = this.persetujuanHasil ? this.persetujuanHasil.id : 0;

    return `ic-${hasilId}-${this.persetujuanNonce}`;
  }

  get bisaInputHasil(): boolean {
    return isUnitBankDarah(userModule.loginUnitId);
  }

  get grupAktif(): any {
    const grup = this.grupJenis as any[];
    return grup.find(g => g.jenis === this.tabAktif) || grup[0] || null;
  }

  @Watch("grupJenis")
  onGrupBerubah(grup: any[]) {
    if (!grup.length) return;
    if (this.tabAktif && grup.some(g => g.jenis === this.tabAktif)) return;
    const awal = this.jenisAwal && grup.find(g => g.jenis === this.jenisAwal);
    this.tabAktif = awal ? awal.jenis : grup[0].jenis;
  }

  @Watch("jenisAwal")
  onJenisAwal(val: string | null) {
    if (val && (this.grupJenis as any[]).some(g => g.jenis === val)) {
      this.tabAktif = val;
    }
  }

 
  private bandsJenis(jenis: string, contoh: HasilDarahRecord | null): string[] {
    const katalog = storeHasilPemeriksaanDarah.katalog || {};
    const meta = (katalog.jenis || {})[jenis];

    if (meta && meta.bands) return meta.bands;

    return contoh && contoh.bands ? contoh.bands : [];
  }


  private punyaBlok(jenis: string, contoh: HasilDarahRecord | null): boolean {
    const katalog = storeHasilPemeriksaanDarah.katalog || {};
    const meta = (katalog.jenis || {})[jenis];

    if (meta) return !!meta.blok;

    return !!(contoh && contoh.blok);
  }
 
  private headersUntuk(jenis: string, contoh: HasilDarahRecord | null) {
    const bands = this.bandsJenis(jenis, contoh);

    const headers: Record<string, unknown>[] = [
      { text: "Tgl / Jam Daftar", value: "daftar_at", width: "130px" },
      { text: "Nomor", value: "nomor", width: "160px" }
    ];

    if (bands.indexOf("golongan") >= 0) {
      headers.push({
        text: "Gol. Darah",
        value: "gol_darah",
        width: "110px",
        sortable: false
      });
    }

    if (bands.indexOf("crossmatch") >= 0) {
      headers.push({
        text: "Donor",
        value: "kesimpulan_donor",
        width: "110px",
        sortable: false
      });
    }

    if (bands.length === 1 && bands[0] === "coombs") {
      headers.push({
        text: "Coomb's (DCT/ICT)",
        value: "coombs",
        width: "130px",
        sortable: false
      });
    }

    if (this.punyaBlok(jenis, contoh)) {
      headers.push({
        text: "Hasil",
        value: "ringkasan_detail",
        sortable: false
      });
    }

    headers.push({
      text: "Status",
      value: "status",
      width: "150px",
      sortable: false
    });
    headers.push({
      text: "Aksi",
      value: "aksi",
      sortable: false,
      align: "end",
      width: "170px"
    });

    return headers;
  }

  get grupJenis() {
    const rows = this.items;

    const katalog = storeHasilPemeriksaanDarah.katalog || {};
    const jenisMeta = katalog.jenis || {};

    const urut: string[] = Object.keys(jenisMeta);
    rows.forEach(r => {
      if (urut.indexOf(r.jenis) < 0) urut.push(r.jenis);
    });

    const grup: Record<string, unknown>[] = [];

    urut.forEach(jenis => {
      
      const items = rows.filter(r => r.jenis === jenis);
      const meta = jenisMeta[jenis];

      if (!meta && !items.length) return;

      grup.push({
        jenis,
        label: (meta && meta.label) || (items.length ? items[0].jenis_label : jenis),
        labelSingkat:
          (meta && meta.label_singkat) || (items.length ? items[0].jenis_label_singkat : jenis),
        bisaTambah: !!meta,
        items,
        headers: this.headersUntuk(jenis, items.length ? items[0] : null)
      });
    });

    return grup;
  }

  mounted() {
    storeHasilPemeriksaanDarah.loadKatalog();
    this.muatUlang();
  }

  @Watch("register")
  onRegisterChange() {
    this.formDialog = false;
    this.editData = null;
    this.modalTtd = false;
    this.signItem = null;
    this.dialogPersetujuan = false;
    this.persetujuanHasil = null;
    this.muatUlang();
  }

  muatUlang() {
    if (!this.register) return;
    storeHasilPemeriksaanDarah.getByRegister(this.register);
    this.muatPersetujuan();
  }

  muatPersetujuan() {
    if (!this.showConsentShortcut || !this.register) return;
    if (StorePersetujuanInkompatibel.registerId === String(this.register)) {
      return;
    }

    StorePersetujuanInkompatibel.getSuketByRegister(this.register);
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  ringkasGolongan(item: HasilDarahRecord): string {
    if (!item.gol_darah) return "-";
    if (!item.rhesus) return item.gol_darah;
    return `${item.gol_darah} Rh ${item.rhesus === "positif" ? "Pos" : "Neg"}`;
  }

  ringkasCoombs(item: HasilDarahRecord): string {
    const label = (storeHasilPemeriksaanDarah.katalog || {}).label_reaksi || {};
    const nilai = (v: string | null) => (v ? label[v] || v : "-");

    if (!item.dct && !item.ict) return "-";

    return `${nilai(item.dct)} / ${nilai(item.ict)}`;
  }

  labelStatus(item: HasilDarahRecord): string {
    return item.is_final ? "Final" : "Draft";
  }

  warnaStatus(item: HasilDarahRecord): string {
    return item.is_final ? "green" : "orange";
  }

  bisaTtdPetugas(item: HasilDarahRecord): boolean {
    return (
      !item.signed_petugas &&
      !!item.petugas_user_id &&
      String(item.petugas_user_id) === String(this.userId)
    );
  }

  tooltipTtd(item: HasilDarahRecord): string {
    if (this.bisaTtdPetugas(item)) {
      return "Verifikasi hasil sebagai Petugas Pemeriksa — order akan selesai";
    }
    if (!item.petugas_user_id) {
      return "Petugas Pemeriksa belum dipilih — buka lembar ini lalu pilih Petugas Pemeriksa";
    }
    return `Menunggu verifikasi ${item.petugas_nama || "Petugas Pemeriksa"} — hanya pembuat hasil yang dapat memverifikasi`;
  }

  bisaHapus(item: HasilDarahRecord): boolean {
    return this.bisaInputHasil && !item.signed_petugas;
  }

  
  bukaForm(item: HasilDarahRecord | null, jenis?: HasilDarahJenis) {
    this.editData = item;
    if (jenis) this.formJenis = jenis;
    this.formDialog = true;
  }

  cetak(item: HasilDarahRecord) {
    HasilDarahSvc.printPdf(item.id);
  }

  adaPersetujuan(item: HasilDarahRecord): boolean {
    return this.persetujuanItems.some(s => {
      const sumber = s && s.content && s.content.sumber_hasil;

      return !!sumber && String(sumber.hasil_id) === String(item.id);
    });
  }

 
  bukaPersetujuan(item: HasilDarahRecord) {
    this.persetujuanHasil = item;
    this.persetujuanBukaForm = !this.adaPersetujuan(item);
    this.persetujuanNonce = Date.now();
    this.dialogPersetujuan = true;
  }

 
  onSaved(tersimpan: HasilDarahRecord | null) {
    this.muatUlang();

    if (
      tersimpan &&
      tersimpan.id &&
      !tersimpan.signed_petugas &&
      String(tersimpan.petugas_user_id) === String(this.userId)
    ) {
      this.bukaTtd(tersimpan);
    }
  }

  bukaTtd(item: HasilDarahRecord) {
    this.signItem = item;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItem) return;

    try {
      const resp = await HasilDarahSvc.signPetugas(this.signItem.id, { password });

      if (resp.data.status == "1") {
        this.modalTtd = false;
        this.signItem = null;
        appModule.addMsgTtd("");
        appModule.NoticeDelay(resp.data.message || "Berhasil memverifikasi");
        this.muatUlang();
        this.$emit("verified");
      }
    } catch {
      this.modalTtd = true;
    }
  }

  konfirmHapus(item: HasilDarahRecord) {
    this.hapusItem = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.hapusItem || this.deleting) return;

    this.deleting = true;
    try {
      const resp = await HasilDarahSvc.destroy(this.hapusItem.id);

      if (resp.data.status == "1") {
        appModule.sendSuccessNotice(resp.data.message || "Berhasil dihapus");
        this.dialogHapus = false;
        this.hapusItem = null;
        this.muatUlang();
      }
    } catch {
      return;
    } finally {
      this.deleting = false;
    }
  }
}
